module.exports = __webpack_public_path__ + "media/promo/panasonic/images/play-8f7487c4801ceaee442f5392dac388ca.svg";